import React, {useEffect} from "react";
import {useSelector} from "react-redux";
import StocksTable, {stockTableWidth} from "../stocks/table/StocksTable";
import Sectors from "./sectors/Sectors";
import Loader from "../elements/Loader";
import PageSection from "../elements/PageSection";
import PageHeading from "../elements/PageHeading";
import SubHeading from "../elements/SubHeading";
import TableContainer from "../elements/TableContainer";
import styled from "styled-components";
import IdeaDetailsModal from "../idea/modal/IdeaDetailsModal";
import {log} from "../../logging/logEvent";
import {useSubscription} from "../subscription/useSubscription";

const Header = styled.div`
    display: flex;
    flex-direction: column;
    padding: 30px 0;
`;

const ActivitiesContainer = styled.div`
    display: flex;
`;

const StocksContainer = styled(TableContainer)`
    margin-right: 20px;
`;

const SectorsContainer = styled(TableContainer)`
    width: 440px
`;

const ActivityPage = ({}) => {
    useSubscription("STOCKS", "/ui/api/stocks", 60);

    useEffect(() => {
        log("PageComponentMounted", {page: "ActivityPage"});
        return () => {};
    }, []);

    const stocks = useSelector(state => state.stocks);

    function renderTable() {
        if (stocks.list !== null) {
            return <StocksTable/>;
        }
        if (stocks.failure !== null) {
            return <div>{`Failed to load: ${stocks.failure}`}</div>
        }
        return (
            <div style={{minWidth: stockTableWidth}}>
                <Loader/>
            </div>
        );
    }

    return (
        <PageSection>
            <Header>
                <PageHeading>
                    Activity In Your Universe
                </PageHeading>
                <div>Global, Market Cap > 3B USD</div>
            </Header>
            <ActivitiesContainer>
                <StocksContainer>
                    <SubHeading>Stocks</SubHeading>
                    {renderTable()}
                </StocksContainer>
                <SectorsContainer>
                    <SubHeading>Sectors</SubHeading>
                    <Sectors/>
                </SectorsContainer>
            </ActivitiesContainer>
            <IdeaDetailsModal/>
        </PageSection>
    )
};

export default ActivityPage;
